import { Button, Section, SectionHeader, scrollTo } from 'flos-react-cvi';
import React from 'react';
import { connect } from 'react-redux';
import { useScrollOnMount } from '../hooks/use-scroll-on-mount';
import {
    selectCurrentStep,
    selectPrimaryType,
    selectResources,
    selectCurrentInsuranceTypeIsValid,
    selectTerminationFeeContentBlock
} from '../store/selectors';
import { completeCurrentInsuranceInfo } from '../store/thunks';
import { CurrentInsuranceDetails } from './current-insurance-details';

function validateCompanySelectMenus(formRef) {
    if (formRef.current) {
        const companySelectMenus = formRef.current.querySelectorAll('flos-select-menu');
        [...companySelectMenus].forEach(menu => {
            menu.dispatchEvent(new CustomEvent('flosValidateFormFields'));
        });
    }
}

const CurrentInsurancesView = ({
    resources,
    isFocusOnThisSection,
    terminationFeeContentBlock,
    primaryType,
    currentInsuranceInfoIsValid,
    completeCurrentInsurance
}) => {
    const scrollTarget = useScrollOnMount();
    const [hasSubmitted, setHasSubmitted] = React.useState(false);
    const formRef = React.useRef();

    React.useEffect(() => {
        if (hasSubmitted && !currentInsuranceInfoIsValid && formRef.current) {
            const formGroupWithError = formRef.current.querySelector('.form-group.has-error');
            if (formGroupWithError) {
                scrollTo(formGroupWithError);
            }
        }
    }, [hasSubmitted, currentInsuranceInfoIsValid]);

    function submit() {
        setHasSubmitted(true);
        validateCompanySelectMenus(formRef);
        completeCurrentInsurance();
    }

    return (
        <Section variant={isFocusOnThisSection ? 'alt' : undefined} ref={scrollTarget}>
            <div className="container" data-testid="current-insurances" ref={formRef}>
                <SectionHeader>{resources.currentInsuranceSectionHeading}</SectionHeader>
                <div className="row">
                    <div className="col-xs-12 col-md-8 col-lg-7">
                        <CurrentInsuranceDetails insuranceType={primaryType} hasSubmitted={hasSubmitted} />
                    </div>
                    {terminationFeeContentBlock && (
                        <div
                            className="col-xs-12 col-md-4 col-lg-offset-1 col-lg-4"
                            dangerouslySetInnerHTML={{
                                __html: terminationFeeContentBlock
                            }}
                        />
                    )}
                </div>
                {isFocusOnThisSection && (
                    <div className="row">
                        <div className="col-md-8 col-xs-12 u-Space-up">
                            <Button onClick={submit} variant="primary" minWidth="wide">
                                {resources.currentInsuranceSectionButtonText}
                            </Button>
                        </div>
                    </div>
                )}
            </div>
        </Section>
    );
};

const mapStates = state => {
    return {
        resources: selectResources(state),
        isFocusOnThisSection: selectCurrentStep(state) === 2,
        currentInsuranceInfoIsValid: selectCurrentInsuranceTypeIsValid(state, selectPrimaryType(state)),
        terminationFeeContentBlock: selectTerminationFeeContentBlock(state),
        primaryType: selectPrimaryType(state)
    };
};

const mapDispatch = {
    completeCurrentInsurance: completeCurrentInsuranceInfo
};

export const CurrentInsurances = connect(mapStates, mapDispatch)(CurrentInsurancesView);
